export default "/**\n * Behavior: Fires a flame blast forwards.\n */\n\n// Pull in module dependencies.\nconst Fire = require(\"fire\");\n\nFire.blast();\n";